var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricetag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6576 21.5501C48.6927 21.5501 51.1531 19.0494 51.1531 15.9645C51.1531 12.8797 48.6927 10.3789 45.6576 10.3789C42.6225 10.3789 40.1621 12.8797 40.1621 15.9645C40.1621 19.0494 42.6225 21.5501 45.6576 21.5501Z",
    stroke: "#E541ED",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7798 30.0993L30.1331 58.1084C27.9859 60.2837 24.5112 60.2808 22.3675 58.102L3.96507 39.3978C1.81569 37.2132 1.81942 33.6701 3.97338 31.4902L31.504 3.62755C32.534 2.58521 33.9282 2 35.3816 2H53.9002C56.9353 2 59.3957 4.50076 59.3957 7.5856V26.1433C59.3957 27.6278 58.8143 29.0513 57.7798 30.0993Z",
    stroke: "#5956E9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricetag);
export default __webpack_public_path__ + "static/media/pricetag.2b9c60ff8a40edaeb0bd48ee99ef5151.svg";
export { ForwardRef as ReactComponent };